import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import * as Sentry from "@sentry/react";
import { HOST } from "Constant/Constant";
import { getQueryString } from "Constant/utils";
import { getOrders } from "store/reducer/order";

export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOST,
  }),

  endpoints: (builder) => ({
    getOrders: builder.mutation({
      query: (getQueryParams) =>
      {
        return {
          url: `/get-admin-orders${getQueryString(getQueryParams)}`,
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled;
          dispatch(
            getOrders({
              data: response.data,
            })
          );
        } catch (error) {
          console.error(">>>>>getOrders error", error);
          Sentry.addBreadcrumb({ category: "api", message: "getOrders mutation failed", level: "error", data: { error } });
          dispatch(getOrders({ data: [] }));
        }
      },
    }),
  }),
});

export const { useGetOrdersMutation } = orderApi;
